<template>
  <main class="main" style="background-color: white;min-height: calc(100vh - 60px);overflow: hidden;">
    <portal to="headerTitle">
      Connect.CX Mapping
    </portal>
    <template v-if="iframe !== null">
      <hm-col cols="12">
        <iframe :src="iframe" style="border: none!important;width:100%;height: calc(100vh - 60px - 60px)" allow="clipboard-write;" @load="showSpinner = false;" />
      </hm-col>
    </template>
    <spinner-overlay v-if="showSpinner" />
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil } from 'lodash';
import TimerMixin from '../../../../mixins/TimerMixin';

export default {
  name: 'PageChannelManagerCxMapping',
  mixins: [HotelmeisterMixin, TimerMixin],

  data() {
    return {
      iframe: null,
      showSpinner: true,
    };
  },

  computed: {
  },

  watch: {
    iframe: function (newVal) {
      if (isNil(newVal)) this.showSpinner = true;
      else this.setTimeout(() => { this.showSpinner = false; }, 2500);
    },
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.channelManagerCx.mappingIframe(this, this.$route.params.configId))
        .then((response) => {
          this.iframe = response.data.data;
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageChannelManagerCxMapping.vue